module.exports = __webpack_public_path__ + "static/media/hybrid-reality.a495196d.jpg";